import { useEffect, useState } from 'react';
import { selectCurrentToken, setCredentials } from '../features/authentication/authSlice';
import { useRefreshMutation } from '../features/authentication/authApiSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const token = useSelector(selectCurrentToken);
  const [refresh] = useRefreshMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    const verifyRefreshToken = async () => {
      try {
        await refresh()
          .unwrap()
          .then((authResponse) => {
            dispatch(
              setCredentials({
                accessToken: authResponse.accessToken
              })
            );
          });
      } catch (ex) {
        console.log(ex);
      } finally {
        setIsLoading(false);
      }
    };

    !token ? verifyRefreshToken() : setIsLoading(false);
  }, []);

  return <>{isLoading ? <div>Loading...</div> : <Outlet />}</>;
};

export default PersistLogin;
